import { capitalize, flow, startCase } from 'lodash';
import { mixpanel as mp } from '@fiverr-private/obs';
import { getContext } from '@fiverr-private/fiverr_context';
import { getWindow, serialize, Serializers } from '../utils';
import { PAGE_NAME } from './monitoring-constants';
import { DefaultData } from './types';

export interface MPClickOptions {
    type: string;
    [key: string]: any;
}

export interface MPPageViewOptions {
    pageName?: string;
    type?: string;
    [key: string]: any;
}

const serializer = Serializers.StartCase;

const format = flow([startCase, capitalize]);

export const mixpanel = {
    event({ type, ...rest }: MPPageViewOptions) {
        this.pageView({ type, ...rest });
    },
    click({ type, ...rest }: MPClickOptions, defaultData: DefaultData = {}) {
        const { userId, organizationId } = getContext();

        const sellerId = defaultData?.seller?.user?.id;

        const payload = serialize(
            {
                ...rest,
                'user id': userId?.toString(),
                'is guest': !userId,
                'organization id': organizationId,
                'seller id': sellerId?.toString(),
                'page name': PAGE_NAME,
            },
            serializer
        );
        const eventName = format(type);

        if (window.MixpanelWrapper) {
            window.MixpanelWrapper.trackEvent(eventName, payload);
        } else {
            mp.track(eventName, payload);
        }
    },
    pageView({ type, ...rest }: MPPageViewOptions, defaultData: DefaultData = {}) {
        const { userId, organizationId } = getContext();

        const sellerId = defaultData?.seller?.user?.id;

        const payload = serialize(
            {
                ...rest,
                'user id': userId?.toString(),
                'is guest': !userId,
                'organization id': organizationId,
                'seller id': sellerId?.toString(),
                'page name': PAGE_NAME,
            },
            serializer
        );

        if (getWindow()?.MixpanelWrapper) {
            if (type) {
                window.MixpanelWrapper?.trackEvent(format(type), payload);
            } else {
                window.MixpanelWrapper?.trackPageView(PAGE_NAME, serialize(rest));
            }
        } else if (type) {
            mp.track(format(type), payload);
        } else {
            mp.trackPageView(payload);
        }
    },
    clickOnContactMeButton({
        source,
        priorInteraction,
        type = 'multi-optional',
    }: {
        source: string;
        priorInteraction: boolean;
        type: 'multi-optional' | 'contact-only';
    }) {
        this.event({
            type: `clicked ${type} contact me`,
            source,
            buyerType: priorInteraction ? 'Repeated' : 'First time',
        });
    },
    contactDropdownDisplayed({ priorInteraction, source }: { priorInteraction: boolean; source: string }) {
        this.event({
            type: 'viewed multi-optional contact Me',
            buyerType: priorInteraction ? 'Repeated' : 'First time',
            source,
        });
    },

    clickOnContactMeOption({
        option,
        priorInteraction,
        sourceComponent,
    }: {
        option: 'Create a brief' | 'Ask a question';
        sourceComponent: 'drawer' | 'dropdown';
        priorInteraction: boolean;
    }) {
        this.event({
            type: 'clicked on contact me option',
            option,
            sourceComponent,
            buyerType: priorInteraction ? 'Repeated' : 'First time',
        });
    },
    redirectToInbox({ priorInteraction, source }: { source: string; priorInteraction: boolean }) {
        this.event({
            type: 'redirected to inbox from contact button',
            source,
            buyerType: priorInteraction ? 'Repeated' : 'First time',
        });
    },
};
